import { NEW_OUTFIT_BEHAVIOUR } from 'feature-flags';
import React, {
  useCallback,
  useMemo,
  useState,
} from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'types/app';
import { Feature } from 'flagged';
import ConfirmationModal from './ConfirmationModal';

function Subscriptions({
  isCancelling,
  subscriptions,
}: Props) {
  const { hasBraintreeSubscription } = subscriptions;

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const onRequestCloseConfirmationModal = useCallback(() => setIsConfirmationModalOpen(false), []);

  const content = useMemo(() => {
    if (hasBraintreeSubscription) {
      return (
        <Feature name={NEW_OUTFIT_BEHAVIOUR}>
          {(enabled: boolean) => (
            <div>
              <p>
                You are currently subscribed to Fallen London.
                {' '}
                You can cancel your subscription at any time.
              </p>
              <p>
                By cancelling your subscription, you will no longer have a second action candle,
                expanded opportunity deck,
                {' '}
                {enabled ? 'two additional outfits,' : ''}
                {' '}
                or access to the House of Chimes.
                You will no longer receive a new Exceptional Story every month.
                You will still be able to spend Memories of a Tale in Mr Chimes' Lost &amp; Found.
              </p>
              <button
                className="button button--primary button--no-margin"
                onClick={() => setIsConfirmationModalOpen(true)}
                type="button"
              >
                {isCancelling ? 'cancelling...' : 'Cancel'}
              </button>
            </div>
          )}
        </Feature>
      );
    }

    return <p>You have no subscriptions.</p>;
  }, [
    hasBraintreeSubscription,
    isCancelling,
  ]);

  return (
    <>
      <div>
        <h2 className="heading heading--2">Subscriptions</h2>
        {content}
      </div>
      <ConfirmationModal isOpen={isConfirmationModalOpen} onRequestClose={onRequestCloseConfirmationModal} />
    </>
  );
}

const mapStateToProps = ({
  settings: { subscriptions },
  subscription: { isCancelling },
}: IAppState) => ({ isCancelling, subscriptions });

type Props = ReturnType<typeof mapStateToProps>;


export default connect(mapStateToProps)(Subscriptions);